import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-140" data-mp="bqiw3nuwu4ts">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-141" data-mp="195wujiubu1cl">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-xl items-center justify-center gap-2 rounded-xl bg-amber px-4 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-ink shadow-[0_5px_0_0_#B45309] focus:outline-none focus-visible:ring-4 focus-visible:ring-white/60" data-id="element-142" data-mp="2f5vaevvsp7g0">
            Get instant access — $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-143" data-mp="1wbgejf4s5uwe" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}